import { z } from 'zod'

// https://docs.elationhealth.com/reference/the-incoming-file-object

export const incomingFileImageSchema = z.object({
  id: z.number(),
  practice: z.number(),
  image_url: z.string().url(),
  rotation: z.number(),
  file_size: z.number(),
  received_date: z.string(),
  sequence: z.number().nullable(),
  original_width: z.number(),
  original_height: z.number(),
  width: z.number(),
  height: z.number(),
  original_rotation: z.number(),
  original_padded: z.number(),
  original_extension: z.string(),
  quality_score: z.number().nullable(),
  quality_score_by: z.string().nullable(),
  created_date: z.string(),
  deleted_date: z.string().nullable(),
  incoming_file: z.number(),
})

export type IncomingFileImage = z.infer<typeof incomingFileImageSchema>

export const incomingFileFileSchema = z.object({
  id: z.number(),
  practice: z.number(),
  content_type: z.string(),
  file_url: z.string().url(),
  file_size: z.number(),
  original_filename: z.string(),
  created_date: z.string(),
  deleted_date: z.string().nullable(),
  incoming_file: z.number(),
})

export type IncomingFileFile = z.infer<typeof incomingFileFileSchema>

export const incomingFileSchema = z.object({
  id: z.number(),
  practice: z.number(),
  source: z.string(),
  received_time: z.string(),
  process_state: z.string(),
  process_start_time: z.string().nullable(),
  process_complete_time: z.string().nullable(),
  process_result: z.string().nullable(),
  practice_fax: z.string().nullable(),
  external_fax_id: z.string().nullable(),
  from_number: z.string().nullable(),
  to_number: z.string().nullable(),
  transmit_time: z.string().nullable(),
  page_count: z.number().nullable(),
  to_name: z.string().nullable(),
  to_company: z.string().nullable(),
  subject: z.string().nullable(),
  group_name: z.string().nullable(),
  file_size: z.number().nullable(),
  created_date: z.string(),
  images: z.array(incomingFileImageSchema),
  files: z.array(incomingFileFileSchema),
})

export type IncomingFile = z.infer<typeof incomingFileSchema>
